module.exports = __webpack_public_path__ + "img/table.502caa62.png";